import { render, staticRenderFns } from "./RealNameAgree.vue?vue&type=template&id=4710a70a&"
import script from "./RealNameAgree.vue?vue&type=script&lang=js&"
export * from "./RealNameAgree.vue?vue&type=script&lang=js&"
import style0 from "./RealNameAgree.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports